import { type FC } from "react";
import { TestModal } from "./TestModal";
import { EditMediaViewModal } from "./EditMediaViewModal";
import { EditDocumentLoaderModal } from "./EditDocumentLoaderModal";
import { DocumentListModalContentModal } from "./DocumentListModalContent";
import { ModalIdProvider } from "@/framework/ModalManager/ModalIdProvider";
import { RestoreDocumentModal } from "./RestoreDocumentModal";
import { AuthErrorModal } from "./AuthErrorModal";

export const ModalManager: FC = () => (
  <>
    <TestModal />
    <EditMediaViewModal />
    <ModalIdProvider>
      <EditDocumentLoaderModal />
    </ModalIdProvider>
    <RestoreDocumentModal />
    <DocumentListModalContentModal />
    <AuthErrorModal />
  </>
);
